import {Icon as LegacyIcon} from '@ant-design/compatible';
import Icon, {
    ApiOutlined,
    CheckOutlined,
    ClusterOutlined,
    ExclamationCircleOutlined,
    LinkOutlined,
    PicCenterOutlined,
    PoweroffOutlined,
    QuestionOutlined,
    VideoCameraOutlined
} from '@ant-design/icons';
import {Alert, Badge, Button, Col, Divider, message, Modal, notification, Progress, Row, Spin, Typography} from 'antd';
import {deviceType, Loader, progressStage, warrantyStatus} from "../utils/const";
import {getUnauthorizedComponent} from 'component/dashboard/slidelist_utils';
import {aclPermissions, hasPermissions} from 'const/ACLPermissions';
import {Component} from "react";
import {connect} from "react-redux";
import {Link, Redirect} from 'react-router-dom';
import LoaderWorkflow from "../component/scanner/loader_workflow";
import ReloadConfigPromptWrapper from '../component/scanner/reload_config_prompt_wrapper';
import ScanWorkflow from "../component/scanner/scan_workflow";
import {get, get_response} from "../helper/request";
import {sagaMiddleware} from "../helper/store";
import {watchPollStatus} from "../redux_actions/device_status.action";
import {updateLiveImagePolling} from "../redux_actions/liveview.action";
import {ProgressStateConstant} from "../redux_constants/progress_state.constant";
import {stopScannerServer} from "../utils/device_utils";
import {scanPageSelector, systemStateNotificationHandler} from "../utils/scanner_utils";
import {getStateAwareUrl, isNull, isTrue, notNull} from '../utils/utils';
import {error_manager} from "../helper/error_manager";

class ScannerView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            allow_workflow_access: false,
            starting_scanner: false,
            scannerServerBusy: false,
            scannerServerBusyMessage: "",
            any_present : false,
            warrantyStatus: null,
            message: null,
        }
        this.usbConnectionCodeDict = {
            DISCONNECTED : "DISCONNECTED",
            CONNECTED : "CONNECTED",
            INITIALISED : "INITIALISED",
            ERRORED : "ERRORED",
            DOES_NOT_EXIST: "DOES_NOT_EXIST",
            UNKNOWN: "UNKNOWN"
        }
        this.hardwareDict = {
            CAMERA : "Main Camera",
            SERIAL : "Serial",
            PREVIEW_CAMERA : "Preview Camera",
            PREVIEW_CAMERA_AND_LOADER: "Preview Camera and Loader",
            UPS: "UPS",
            POWER: "Power"
        }
        this.powerStatusDict = {
            UNKNOWN : "UNKNOWN",
            DISCONNECTED : "DISCONNECTED",
            CONNECTED : "CONNECTED",
            ONLINE: "ONLINE",
            ONBATT: "ONBATT"
        }
        this.systemStateDict = {
            CRITICAL : "CRITICAL",
            WARNING : "WARNING",
            AVAILABLE : "AVAILABLE"
        }
        this.notificationTypeDict = {
            HDD : 'hdd',
            SSD : 'ssd',
            STOP : 'stop'
        }

        this.poller = null

    }

    startScanner = (wait_for_init) => {
        let id = this.props.match.params.id;
        this.setStartingScanner();
        let url = `/delayed_server/devices/` + id + '/start_scanner/';
        get_response(url)
            .then(response => {
                if (response.status === 200) {
                    if (wait_for_init) {
                        this.setDoneStartingScanner();
                    }
                }
                else {
                    if (wait_for_init) {
                        this.setDoneStartingScanner();
                        message.error("Failed to Start Scanner. Contact Admin");
                    }
                }
            })
            .catch(err => {
                if (wait_for_init) {
                    this.setDoneStartingScanner();
                    error_manager("", err)
                }
            })
            if (!wait_for_init) {
                this.setDoneStartingScanner();
            }
    }

    startScannerServer = () => {
        let id = this.props.match.params.id;
        this.setScannerServerBusy("Booting Scanner");
        let url = `/delayed_server/devices/` + id + '/start_scanner_server/';
        get_response(url)
            .then(response => {
                if (response.status !== 200) {
                    message.error("Failed to Start Scanner. Contact Admin!");
                    this.setScannerServerIdle();
                }
            })
            .catch(err => {
                this.setScannerServerIdle();
                error_manager("", err);
            })

    }

    stopScannerServer = () => {
        stopScannerServer(this.props.match.params.id,
            () => this.setScannerServerBusy("Shutting Down Scanner"),
            () => this.setScannerServerIdle(),
            () => this.setScannerServerIdle()
        );
    }

    setStartingScanner = () => this.setState(Object.assign({}, this.state, { starting_scanner: true }));

    setDoneStartingScanner = () => this.setState(Object.assign({}, this.state, { starting_scanner: false }));

    setScannerServerBusy = (message) => this.setState(Object.assign({}, this.state, { scannerServerBusy: true, scannerServerBusyMessage : message }));

    setScannerServerIdle = () => this.setState(Object.assign({}, this.state, { scannerServerBusy: false }));

    componentDidMount() {
        this.poller = sagaMiddleware.run(watchPollStatus, this.props.dispatch, this.props.match.params.id);
        this.getLiveImagePollingStatus();
        this.allowWorkflowAccess();
        get('/api/get_warranty_details/').then(data => {
            if (data['warranty_status'] !== warrantyStatus.VALID) {
                this.setState({
                    warrantyStatus: data['warranty_status'],
                    message: data['message']
                })
            }
        }).catch((error) => error_manager("", error))
    }

    componentWillUnmount() {
        this.poller.cancel()
    }

    getLiveImagePollingStatus = () => {
        let partsOfUrl = "api~camera~get_live_image_polling_status/";
        let url = `/server/scano/` + this.props.match.params.id + `/` + partsOfUrl;
        get_response(url)
            .then(response => {
                if (response.status === 200) {
                    this.props.dispatch(updateLiveImagePolling(response.data));
                }
                else {
                    console.log(response);
                }
            })
            .catch(err => console.log(err));
    }

    allowWorkflowAccess = () => this.setState(Object.assign({}, this.state, { allow_workflow_access: true }));

    revokeWorkflowAccess = () => this.setState(Object.assign({}, this.state, { allow_workflow_access: false }));

    getIconType = (usbConnectionCode) => {
        if (usbConnectionCode === this.usbConnectionCodeDict.INITIALISED) {
            return <CheckOutlined className="hardware-status-icon" style={{color:this.getColorType(usbConnectionCode)}}/>
        } else if (usbConnectionCode === this.usbConnectionCodeDict.DISCONNECTED) {
            return <ApiOutlined className="hardware-status-icon" style={{color:this.getColorType(usbConnectionCode)}}/>
        } else if (usbConnectionCode === this.usbConnectionCodeDict.CONNECTED) {
            return <LinkOutlined className="hardware-status-icon" style={{color:this.getColorType(usbConnectionCode)}}/>
        } else if (usbConnectionCode === this.usbConnectionCodeDict.ERRORED) {
            return <ExclamationCircleOutlined />
        } else if (usbConnectionCode === this.usbConnectionCodeDict.UNKNOWN) {
            return <QuestionOutlined className="hardware-status-icon" style={{color:this.getColorType(usbConnectionCode)}}/>
        }
    }

    getColorType = (usbConnectionCode) => {
        if (usbConnectionCode === this.usbConnectionCodeDict.INITIALISED) {
            return "#27ae60";
        } else if (usbConnectionCode === this.usbConnectionCodeDict.DISCONNECTED) {
            return "#c0392b";
        } else if (usbConnectionCode === this.usbConnectionCodeDict.CONNECTED) {
            return "#27ae60";
        } else if (usbConnectionCode === this.usbConnectionCodeDict.ERRORED) {
            return "#c0392b";
        } else if (usbConnectionCode === this.powerStatusDict.ONBATT || usbConnectionCode === this.usbConnectionCodeDict.UNKNOWN) {
            return "#FF0000";
        }
    }

    getHelpText = (device, usbConnectionCode) => {
        let line1, line2;

        const linking_verb = device === this.hardwareDict.PREVIEW_CAMERA_AND_LOADER ? "are" : "is";
        if (usbConnectionCode === this.usbConnectionCodeDict.INITIALISED) {

            line1 = device + ` ${linking_verb} connected and initialised`;
            line2 = "";
        } else if (usbConnectionCode === this.usbConnectionCodeDict.DISCONNECTED) {
            line1 = device + ` ${linking_verb} disconnected`;
            line2 = "Please reconnect the cable tagged " + device;
            if(device === this.hardwareDict.POWER){
                line1 = "Please switch on the power button of machine and Initialize";
                line2 = "Note: Do not disconnect any of USB cables, if you do restart scanner.";
            }
        } else if (usbConnectionCode === this.usbConnectionCodeDict.CONNECTED) {
            line1 = device + ` ${linking_verb} connected and ready for startup`;
            line2 = "";
        } else if (usbConnectionCode === this.usbConnectionCodeDict.ERRORED) {
            line1 = "Please remove and reconnect the cable tagged " + device;
            line2 = "Click the START SCANNER button once done";
        }else{
            line1 = "Checking the Status";
            line2 = "";
        }

        return [
            <span key={0}>{line1}</span>,
            <br key={1}></br>,
            <span key={2} className="hardware-section-retry">{line2}</span>
        ]
    }

    getIconForDevice = (device) => {
        if (device === this.hardwareDict.CAMERA) {
            return <VideoCameraOutlined className="hardware-status-icon" />
        } else if (device === this.hardwareDict.SERIAL) {
            return <ClusterOutlined className="hardware-status-icon" />
        }  else if (device === this.hardwareDict.PREVIEW_CAMERA || device === this.hardwareDict.PREVIEW_CAMERA_AND_LOADER) {
            return <PicCenterOutlined className="hardware-status-icon" />
        } else if (device === this.hardwareDict.UPS) {
            return <PoweroffOutlined className="hardware-status-icon" />
        }
    }

    getHardwareRowPanel = (device, status) => {
        return (
            <Row className="hardware-status-row">
                <Col span={3} className="hardware-status-icon-div">
                    {this.getIconForDevice(device)}
                </Col>
                <Col span={17} className="hardware-section-header">
                    <b>{device}</b>
                    <Divider />
                    {this.getHelpText(device, status)}
                </Col>
                <Col span={4} className="hardware-status-icon-div">
                    {this.getIconType(status)}
                </Col>
            </Row>
        );
    }

    getPowerStatusBlock = (deviceHEAD, deviceText, status) => {
        return <div>
        <Col span={17} className="hardware-section-header">
            <b>{deviceHEAD}</b>
            <Divider />
            {this.getHelpText(deviceText, status)}
        </Col>
        <Col span={4} className="hardware-status-icon-div">
            <Icon
                className="hardware-status-icon"
                type={status === this.usbConnectionCodeDict.DISCONNECTED && deviceText === this.hardwareDict.POWER? 'alert' :this.getIconType(status)}
                style={{color:this.getColorType(status)}} >
            </Icon>
        </Col>
        </div>
    }

    getUPSRowPanel = (device, status, upsPowerStatus, upsMandatory, powerStatus) => {
        return (
            <Row className="hardware-status-row">
                <Col span={3} className="hardware-status-icon-div">
                    {this.getIconForDevice(device)}
                </Col>
                {upsMandatory ? upsPowerStatus.powerStatus === this.powerStatusDict.ONBATT ?
                <div>
                <Col span={17} className="hardware-section-header">
                    <b>{device}</b>
                    <Divider />
                    <Row className="power-fail-message">
                        <span style={{color:"#c0392b"}}><ExclamationCircleOutlined></ExclamationCircleOutlined></span>  &nbsp;
                        UPS is not connected to wall power socket. Please check.
                    </Row>
                </Col>
                <Col span={4} className="hardware-status-icon-div">
                    <Icon
                        className="hardware-status-icon"
                        type='alert'
                        style={{color:this.getColorType(upsPowerStatus.powerStatus)}} >
                    </Icon>
                </Col>
                </div> : powerStatus === this.usbConnectionCodeDict.DISCONNECTED && status !== this.usbConnectionCodeDict.DISCONNECTED ? this.getPowerStatusBlock(device, this.hardwareDict.POWER, powerStatus)
                : this.getPowerStatusBlock(device, device, status) : this.getPowerStatusBlock(this.hardwareDict.POWER, this.hardwareDict.POWER, powerStatus)}
            </Row>
        );
    }

    openPowerNotification = (key, upsPowerStatus) => {
        notification.open({
            key,
            message: upsPowerStatus.powerStatus === this.powerStatusDict.ONBATT ? 'Scanner on Battery Power' :
                        'UPS disconnected from computer',
            icon: <LegacyIcon type={upsPowerStatus.timeToShutdownInSeconds > 0 ?'alert':'frown'} style={{color:"#FF0000"}} ></LegacyIcon>,
            duration: 0,
            description: upsPowerStatus.timeToShutdownInSeconds > 0 ? <div><b>{upsPowerStatus.powerStatus === this.powerStatusDict.ONBATT ? 'Please consider reconnecting to power supply.':
                  'Unable to get the the power state. Please check the cable.'}</b>
             <p>Time remaininig before the shutdown. </p>
             <Progress status="active" percent={(upsPowerStatus.timeToShutdownInSeconds/upsPowerStatus.timeBufferForPowerFailure)*100}
                       showInfo={false}
                       strokeColor={{
                        from: '#ff3300',
                        to: '#87d068',
                      }}/>
             {Math.floor(upsPowerStatus.timeToShutdownInSeconds/60)}:{upsPowerStatus.timeToShutdownInSeconds%60} Minutes</div> :
        <div>{"Scanner Stopped. Connect the Power Supply to resume."}</div>,
            placement: 'bottomRight',
        });
    };

    closeNotification = (key) => {
        notification.close(key);
    };

    isObjEmpty = (obj) => {
        for(var key in obj) {
            if(obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }

    checkStage = () => {
        let id = this.props.match.params.id;
        this.setStartingScanner();
        let url = `/server/devices/` + id + "/manualmode/check-stage/";
        get_response(url)
            .then(response => {
                message.info("Stage Check Success");
                this.setDoneStartingScanner();
            })
            .catch(err => {
                message.error("Stage Check Failure");
                this.setDoneStartingScanner();
            });
    }

    warrantyButton() {
        let warning = true;
        if (this.state.warrantyStatus === warrantyStatus.EXPIRED) {
            warning = false;
        }
        const btn = warning ? (
            <Button type="primary" size="small" onClick={() => {
                this.setState({
                    warrantyStatus: undefined
                })
                get("/api/snooze_warranty/")
            }} ghost>
                Snooze for 7 Days
            </Button>
        ) : null;
        return <Row style={{
            position: 'fixed',
            bottom: 0,
            width: '100%',
            padding: '8px 8px 8px 8px',
            animation: warning ? 'shadow-pulse-warn 1.5s infinite' : 'shadow-pulse-error 1.5s infinite',
            textAlign: 'center',
            backgroundColor: warning ? 'orange' : '#ff4d4f',
            borderColor: warning ? 'orange' : '#ff4d4f'
            }} offset={6}>
                <Typography>
                    <Typography.Text strong>
                        {warning ? "Scanner Warranty Expiring Soon. " : "Scanner Warranty Expired! "}
                        {this.state.message}
                        {"  "}
                        {btn}
                    </Typography.Text>
                </Typography>
        </Row>;
    }

    handleOpenModal = () => {
        this.setState({modalVisible: true});
    };

    render() {
        if (!hasPermissions([aclPermissions.view_scanner])) return getUnauthorizedComponent()

        if (!this.props.sessionValid)
            return <Alert message="You have just logged in somewhere else. This session will logout! Please login again to activate this session" banner />

        let allUsbDevicesConnected = true; // FIXME: this is actually all USB and RJ45 devices (since we have a RPi preview camera now)
        let scannerStatus = (((this.props.device || {}).scanner_health || {}).scanner_response || {});
        let usbDependenciesStatus = (scannerStatus || {}).usbDependenciesStatus;
        let httpDependenciesStatus =  (scannerStatus || {}).httpDependenciesStatus;
        let upsPowerStatus = ((scannerStatus || {}).upsPowerStatus || {});
        let powerStatus = ((scannerStatus || {}).powerStatus || {});
        let upsMandatory = ((((this.props.device || {}).scanner_health || {}).scanner_response || {}).usbDependenciesStatus || {}).upsStatus !== this.usbConnectionCodeDict.DOES_NOT_EXIST;
        let systemState = ((scannerStatus || {}).systemState || {});
        let isCriticalDisk = systemState.ssdStatus === this.systemStateDict.CRITICAL || systemState.hddStatus === this.systemStateDict.CRITICAL;
        let isMorpheusReachable = ((this.props.device || {}).scanner_health || {}).device_name
        isMorpheusReachable = notNull(isMorpheusReachable) ? isMorpheusReachable : false;
        let isServerReachable = ((this.props.device || {}).scanner_health || {}).server_up
        isServerReachable = notNull(isServerReachable) ? isServerReachable : false;
        let hardwareError = false;
        let stageEncoderFailure = scannerStatus.stageEncoderFailure;
        let restoringErroredRPI = scannerStatus.restartingRPIForIOError;

        let recommendServerRestart = (scannerStatus || {}).recommendServerRestart;
        recommendServerRestart = recommendServerRestart === undefined ? false : recommendServerRestart;

        if (usbDependenciesStatus !== undefined) {
            for (let key in usbDependenciesStatus) {
                if (usbDependenciesStatus[key] !== this.usbConnectionCodeDict.INITIALISED && key !== 'upsStatus') {
                    hardwareError = true;
                }
                if (usbDependenciesStatus[key] !== this.usbConnectionCodeDict.INITIALISED &&
                    usbDependenciesStatus[key] !== this.usbConnectionCodeDict.CONNECTED && key !== 'upsStatus'
                    && key !== 'previewStatus') {
                    allUsbDevicesConnected = false;
                }
                if (key === 'previewStatus'
                    && ((usbDependenciesStatus['previewStatus'] !== this.usbConnectionCodeDict.INITIALISED
                         && usbDependenciesStatus['previewStatus'] !== this.usbConnectionCodeDict.CONNECTED)
                       && (httpDependenciesStatus['piCameraStatus'] !== this.usbConnectionCodeDict.INITIALISED
                         && httpDependenciesStatus['piCameraStatus'] !== this.usbConnectionCodeDict.CONNECTED)) ) {
                    allUsbDevicesConnected = false;
                }
            }

            // Check for ups Power connection on start

            if (upsMandatory) {
                if(upsPowerStatus.deviceStarted === false
                    && upsPowerStatus.powerStatus === this.powerStatusDict.ONBATT) {
                    allUsbDevicesConnected = false;
                }

                if(upsPowerStatus.deviceStarted === false
                    && usbDependenciesStatus.upsStatus !== this.usbConnectionCodeDict.INITIALISED) {
                    allUsbDevicesConnected = false;
                }
            }
        }

        let isScanning = scannerStatus.scanning;

        let isPreviewOngoing = false;
        if (notNull(scannerStatus?.scanPreviewStatus) && Object.keys(scannerStatus?.scanPreviewStatus).length > 0){
            isPreviewOngoing = Object.values(scannerStatus?.scanPreviewStatus).some((preview) => isTrue(preview.previewOngoing));
        }

        isScanning = isScanning === undefined ? false : isPreviewOngoing ? false : isScanning;
        let isInitialized = scannerStatus.initialized; 
        const preventInit = scannerStatus.preventInit;
        isInitialized = isInitialized === undefined ? false : isInitialized;
        let isStartedInit = scannerStatus.startedInit;
        isStartedInit = isStartedInit === undefined ? false : isStartedInit;

        let isBusy = scannerStatus.busy;
        isBusy = isBusy === undefined ? false : isBusy;
        let uiBusy = isBusy || (this.props.device || {}).uiBusy;
        uiBusy = uiBusy === undefined ? false : uiBusy;
        let progressState = this.props.match.params.progress_stage === undefined ? ProgressStateConstant.MAINPAGE : this.props.match.params.progress_stage;

        let loaderPresent = this.props.deviceProperties?.loaderPresent || false;

        let scanner_control = null;
        let busyMessage = null;

        if (this.state.scannerServerBusy || ((this.props.device || {}).scanner_health || {}).server_starting) {
            uiBusy = true;
            busyMessage = this.state.scannerServerBusyMessage;
        }

        if (isBusy) {
            let busyOrder = scannerStatus.busyOrder;
            let busyDict = scannerStatus.busyDict;
            busyMessage = busyOrder.length > 0 ? busyDict[busyOrder[busyOrder.length - 1]] : "";
        } else if (uiBusy) {
            isBusy = true;
        }
        let deviceName =  (((this.props.device || {}).scanner_health || {}).scanner_response || {})['deviceType']
        let isContinuumScanner = deviceName && deviceName === deviceType.MORPHOLENS_240;

        if (isServerReachable && recommendServerRestart) {
            uiBusy = false; // don't prevent user from interaction here
            scanner_control = <Row>
                <Col className="hardware-status-panel" span={12} offset={6}>
                    <Row className="troubleshoot-fail-message">
                        <span
                            style={{color: "#c0392b"}}><ExclamationCircleOutlined></ExclamationCircleOutlined></span>  &nbsp;
                        Hardware is not able to restart after multiple resets.
                    </Row>
                    <Row className="troubleshoot-steps">
                        <ol>
                            <li>Remove the cable tagged <b>CAMERA</b></li>
                            <li>Put the cable tagged <b>CAMERA</b> in the same USB port it was removed from</li>
                            <li>Remove the two cables tagged <b>SERIAL</b> and <b>PREVIEW CAMERA</b></li>
                            <li>Put the cables tagged <b>SERIAL</b> and <b>PREVIEW CAMERA</b> in the same USB and LAN
                                ports they were removed from
                            </li>
                            <li>Check the main <b>POWER</b> cable and switch. The switch should be in
                                the <b>ON</b> position and lit <b>RED</b></li>
                            <li>Click the <b>SHUTDOWN SCANNER</b> button below and then click <b>START SCANNER</b> on
                                the next screen
                            </li>
                        </ol>
                    </Row>
                    <Row>
                        {this.getScannerShutDownButton()}
                    </Row>
                </Col>
            </Row>
        } else if (stageEncoderFailure) {
            uiBusy = false; // don't prevent user from interaction here
            scanner_control = <Row>
                <Col className="hardware-status-panel" span={12} offset={6}>
                    <Row span={17} className="hardware-section-header">
                        <h2>{"Stage is not set properly. Please fix the stage and check again."}</h2>
                        {scannerStatus.encoderMessage}
                    </Row>
                    <Row className="scanner-start-button-div">
                        <Button className="scanner-start-button" type="primary" size="large" onClick={this.checkStage}>
                            Check Stage
                        </Button>
                    </Row><Divider></Divider>
                    <Row span={17} className="hardware-section-header">
                        <h4>{"Note: Contact Support if unable to fix this after multiple attempts."}</h4>
                    </Row>
                </Col>
            </Row>
        } else if (!isInitialized && preventInit) {
            // show warning to user and ask them to contact Morphle
            uiBusy=false;
            scanner_control = <Row>
                <Col className="hardware-status-panel" span={12} offset={6}>
                    <Row className="troubleshoot-fail-message">
                        <span style={{color:"#c0392b"}}><ExclamationCircleOutlined></ExclamationCircleOutlined></span>  &nbsp;
                        Something out of the ordinary occurred. You might want to reach out to the Morphle Team to regain access.
                    </Row>
                    <Row className="troubleshoot-steps">
                        <ol>
                            <li>Please contact <b>Morphle Admin</b></li>
                            <li>Avoid using the scanner before contacting <b>Morphle Admin</b></li>
                        </ol>
                    </Row>
                    <Row>
                        {this.getScannerShutDownButton()}
                    </Row>
                </Col>
            </Row>
        } else if (!isInitialized && (!allUsbDevicesConnected || hardwareError) && this.props.device && usbDependenciesStatus) {
            if (this.state.scannerServerBusy) {
                this.setScannerServerIdle();
            }
            let previewCameraStatus = (usbDependenciesStatus["previewStatus"] === this.usbConnectionCodeDict.CONNECTED)
            || (httpDependenciesStatus["piCameraStatus"] === this.usbConnectionCodeDict.CONNECTED) ?
                this.usbConnectionCodeDict.CONNECTED
                : ((usbDependenciesStatus["previewStatus"] === this.usbConnectionCodeDict.INITIALISED)
                    || (httpDependenciesStatus["piCameraStatus"] === this.usbConnectionCodeDict.INITIALISED)) ?
                    this.usbConnectionCodeDict.INITIALISED : this.usbConnectionCodeDict.DISCONNECTED;
            scanner_control = <Row>
                <Col className="hardware-status-panel" span={12} offset={6}
                     style={{marginTop: 50}}>
                    <Row span={17} className="hardware-section-header">
                        {"Please ensure that scanner is connected to uninteruppted power supply"}
                    </Row>
                    { isStartedInit ? this.getUPSRowPanel(this.hardwareDict.UPS, usbDependenciesStatus["upsStatus"], upsPowerStatus, upsMandatory, powerStatus): undefined}
                    {this.getHardwareRowPanel(this.hardwareDict.SERIAL, usbDependenciesStatus["arduinoStatus"])}
                    {this.getHardwareRowPanel(this.hardwareDict.CAMERA, usbDependenciesStatus["cameraStatus"])}
                    {this.getHardwareRowPanel(this.hardwareDict.PREVIEW_CAMERA_AND_LOADER, previewCameraStatus )}
                    <Row className="scanner-start-button-div">
                        <Button className="scanner-start-button" size="large" type={"primary"} ghost
                                disabled={!allUsbDevicesConnected || isCriticalDisk || isNull(isContinuumScanner)}
                                onClick={() => this.startScanner(!isContinuumScanner)} autofocus>
                            Initialize Scanner
                        </Button>
                    </Row>
                </Col>
            </Row>
        } else if (isMorpheusReachable && !isServerReachable) {
            scanner_control = <Row className="rounded-container">
                <Col className="hardware-status-panel" span={12} offset={6} style={{borderWidth:0}}>
                    <Row className="scanner-start-button-div">
                        <Button className="scanner-start-button"
                                type="primary" ghost
                                size="large" onClick={this.startScannerServer}>
                            Start Scanner
                        </Button>
                    </Row>
                </Col>
            </Row>
        } else if (isMorpheusReachable) {
            if (loaderPresent) {
                scanner_control = <LoaderWorkflow id={this.props.match.params.id} revokeWorkflowAccess={this.revokeWorkflowAccess} />;
            }
            else {
                const scanURL = scanPageSelector(this.props.match.params.id);                
                if (allUsbDevicesConnected) {
                    if (isContinuumScanner && !restoringErroredRPI) {
                        window.location.pathname = getStateAwareUrl('/c240_control_panel/' + this.props.match.params.id + '/')
                    } else if (notNull(scannerStatus?.scanPreviewStatus) && isPreviewOngoing) {
                        window.location.pathname = getStateAwareUrl('/scannerflow/' + this.props.match.params.id + '/'+ scanURL + '/' + progressStage.SET_PARAMETERS + "/");
                    }
                    else if (notNull(scannerStatus?.scanPreviewStatus) && isScanning) {
                        window.location.pathname = getStateAwareUrl('/scannerflow/' + this.props.match.params.id + '/' + scanURL + '/' + progressStage.SCANNING + "/");
                    }
                    else if (progressState === ProgressStateConstant.WORKFLOW) {
                        if (this.state.allow_workflow_access || loaderPresent) {
                            if (loaderPresent !== undefined) {
                                scanner_control = loaderPresent ? <LoaderWorkflow id={this.props.match.params.id} revokeWorkflowAccess={this.revokeWorkflowAccess} /> :
                                    <ScanWorkflow id={this.props.match.params.id} revokeWorkflowAccess={this.revokeWorkflowAccess} />
                            }
                        } else {
                            scanner_control = <Redirect to={ '/scanners/' + this.props.match.params.id + '/'}></Redirect>
                        }
                    }
                    else if (allUsbDevicesConnected) {
                        window.location.pathname = getStateAwareUrl('/scannerflow/' + this.props.match.params.id + '/' + scanURL + '/' + progressStage.LOAD_SLIDES + "/");
                    } else {
                        uiBusy = false; // don't prevent user from interaction here
                        scanner_control =
                            <Row>
                                <Col className="hardware-status-panel" span={12} offset={6}>
                                    <Row className="troubleshoot-fail-message">
                                        <span style={{color:"#c0392b"}}><ExclamationCircleOutlined></ExclamationCircleOutlined></span>  &nbsp;
                                        Unexpected state.
                                    </Row>
                                    <Row className="troubleshoot-steps">
                                        <ol>
                                            <li>Please check that Power is ON and all ports from Scanner are connected.</li>
                                            <li>Then <b>Force Shutdown Scanner</b> and Start again.</li>
                                        </ol>
                                    </Row>
                                    <Row>
                                        <Col offset={9} span={8} onClick={this.stopScannerServer} style={{cursor: 'pointer'}}>
                                            <Row style={{color:"#22A7F0"}}>
                                                <Col offset={3} span={22}>
                                                    <PoweroffOutlined className="scanner-main-control-icon" style={{color: 'red', fontSize: '50px'}} />
                                                </Col>
                                            </Row>
                                            <Row className="arial-font">
                                                <Col offset={0} span={14}>Force Shutdown Scanner</Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                    }
                } else {
                    uiBusy = false; // don't prevent user from interaction here
                    scanner_control =
                        <Row className="rounded-container">
                            <Col className="hardware-status-panel" span={12} offset={6}>
                                <Row className="troubleshoot-fail-message">
                                    <span style={{color:"#c0392b"}}><ExclamationCircleOutlined></ExclamationCircleOutlined></span>  &nbsp;
                                    All required Hardware is not connected.
                                </Row>
                                <Row className="troubleshoot-steps">
                                    <ol>
                                        <li>Please check that Power is ON and all ports from Scanner are connected.</li>
                                        <li>Then <b>Force Shutdown Scanner</b> and Start again.</li>
                                        <li>This usually happens when Scanner's Power is turned Off while running.</li>
                                    </ol>
                                </Row>
                                <Row>
                                    <Col offset={9} span={8} onClick={this.stopScannerServer} style={{cursor: 'pointer'}}>
                                        <Row style={{color:"#22A7F0"}}>
                                            <Col offset={3} span={22}>
                                                <PoweroffOutlined className="scanner-main-control-icon" style={{color: 'red', fontSize: '50px'}} />
                                            </Col>
                                        </Row>
                                        <Row className="arial-font">
                                            <Col offset={0} span={14}>Force Shutdown Scanner</Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                }
            }
        } else {
            scanner_control = <Loader />
            setTimeout(() => {
                scanner_control = <Row className="rounded-container">
                    <Col className="hardware-status-panel" span={12} offset={6} style={{borderWidth:0}}>
                        <Row className="scanner-start-button-div">
                            Please wait while Scanner Page is loading. <br/>
                            If loading is taking longer, Please try logging out and login again.
                        </Row>
                        <Row className="scanner-start-button-div">
                            <Button
                                className="scanner-start-button"
                                type="primary" ghost
                                size="large"
                                onClick={() => window.location.reload()}>
                                Retry
                            </Button>
                        </Row>
                    </Col>
                </Row>
            }, 2000);
        }

        if(restoringErroredRPI){
            // show message to user
            if (this.state.scannerServerBusy) {
                this.setScannerServerIdle();
            }
            scanner_control = <Row className="rounded-container">
                <Col className="hardware-status-panel" span={12} offset={6}>
                    <Row className="troubleshoot-fail-message">
                        <span style={{color:"#2b4bc0"}}><ExclamationCircleOutlined></ExclamationCircleOutlined></span>  &nbsp;
                        Recalibrating the scanner for operations.
                    </Row>
                    <Row className="troubleshoot-steps">
                        <ol>
                            <li>The Queued Items will resume once the scanner is calibrated</li>
                            <li>The Calibration will be completed in few minutes</li>
                            <li>Please Contact Morphle Support <b>if this screen persists for more than 30 minutes</b></li>
                        </ol>
                    </Row>
                </Col>
            </Row>
        }

        const powerNotifierKey = "powerNotification";
        if(upsPowerStatus.deviceStarted === true &&
            (upsPowerStatus.powerStatus === this.powerStatusDict.ONBATT || upsPowerStatus.powerStatus === this.usbConnectionCodeDict.DISCONNECTED)){
                this.openPowerNotification(powerNotifierKey, upsPowerStatus)
            }
            else{
                this.closeNotification(powerNotifierKey)
        }

        systemStateNotificationHandler(systemState, this.close, this.state.keepCrashedNotification);

        if (isNull(scanner_control)) {
            console.error("code bug, scanner_control is null or undefined");
        }

        let process_status = ((this.props.device || {}).scanner_health || {}).process_status;
        let badges = [];
        for(var p in process_status){
            if(process_status[p][1] === 0){
                badges.push(<Badge status="default" />)
            }else if(process_status[p][1] === 1){
                badges.push(<Badge status="processing" />)
            }else{
                badges.push(<Badge status="error" />)
            }
        }

        return (
            <div style={{backgroundColor: "white", padding: "20px"}} className={"full-parent"}>
                <Row className="scanner-name-div">
                    <Col className="scanner-name" style={{fontSize: 30, fontWeight: 400}} span={18} offset={3}>
                        <Link to={"/scanners/" + this.props.match.params.id + "/"} className="device-name">
                            {(((this.props.device || {}).scanner_health || {}).device_name || 'Morphle')} <span
                            style={{marginLeft: 15}}>Control Panel</span>
                        </Link>
                    </Col>

                    <Col span={3} style={{textAlign: 'right'}}>
                        <Button onClick={this.handleOpenModal} type='primary' className={"shutdown-scanner-btn"}
                                disabled={isMorpheusReachable && !isServerReachable}>
                            Shut Down Scanner
                        </Button>
                    </Col>
                </Row>
                <Divider style={{background: '#000', opacity: "0.2", margin: 5}}/>
                <Modal
                    title="Confirm Shutdown Scanner"
                    visible={this.state.modalVisible}
                    onCancel={() => this.setState({modalVisible: false})}
                    footer={[
                        <Button
                            key="cancel"
                            onClick={() => this.setState({modalVisible: false})}
                        >
                            Cancel
                        </Button>,
                        <Button
                            key="confirm"
                            type={"danger"} ghost
                            onClick={() => {
                                this.stopScannerServer();
                                this.setState({modalVisible: false});
                            }}
                        >
                            Confirm
                        </Button>,
                    ]}
                >
                    Are you sure you want to shutdown the scanner?
                </Modal>
                <Spin spinning={uiBusy || this.state.starting_scanner} tip={busyMessage} size="large">
                    <ReloadConfigPromptWrapper deviceId={this.props.match.params.id}>
                        {scanner_control}
                    </ReloadConfigPromptWrapper>
                </Spin>
                {this.state.warrantyStatus ? this.warrantyButton() : null}
            </div>
        )
    }

    getScannerShutDownButton() {
        return <Col offset={10} span={8} onClick={this.stopScannerServer} style={{cursor: 'pointer'}}>
            <Row style={{color: "#22A7F0"}}>
                <Col offset={2} span={22}>
                    <PoweroffOutlined className="scanner-main-control-icon" style={{color: 'red', fontSize: '50px'}}/>
                </Col>
            </Row>
            <Row className="arial-font">
                <Col offset={1} span={14}>Shutdown Scanner</Col>
            </Row>
        </Col>;
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        device: state.deviceStatusReducer[ownProps.match.params.id],
        previews: state.previewStatusReducer,
        sessionValid: state.sessionStatusReducer.sessionValid,
        deviceProperties: state.deviceAlert.deviceProperties,
    };
};

export default connect(mapStateToProps)(ScannerView);
